import React from "react";
import { LanguagesWithLanguageCode } from "../../../utils/constants.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const mapLanguage = l => ({ key: l.code, name: l.Name });

const LanguageDropdown = ({
  resources,
  language,
  onLanguageChange,
  containerClass,
  filter,
  id = "language-dropdown",
  disabled = false,
  addMarginBottom = false,
  helperText,  
  defaultValue = null,
  noPlaceholder = true,
  required = false,
}) => {

  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={resources["Language"]}
      value={language}
      required={required}
      placeholder={noPlaceholder ? null : defaultValue ?? resources["All"]}
      values={LanguagesWithLanguageCode}
      handleChange={onLanguageChange}
      inputName="language"
      addMarginBottom={addMarginBottom}
      disabled={disabled}
      containerClass={containerClass}
      map={mapLanguage}
      filter={filter}
      helperText={helperText}
    />
  );
};

export default LanguageDropdown;
